module.exports = __webpack_public_path__ + "static/img/FoundWinnersTop.770b31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FoundWinnersTop.png
// module id = Om4x
// module chunks = 4